<template>
  <div>
    <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
    <div class="innerWrapper">
      <h1>Admin Sign-in</h1>
      <div class="ui active inline loader" v-show="signingIn"></div>
      <div class="ui input" v-show="!signingIn">
        <input type="text" v-model="userId"  placeholder="User ID" @keyup.enter="signIn()">
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'

const firebase = window.firebase
const db = firebase.firestore()

function logError (errorCode, error) {
  console.log(errorCode)
  console.log(error)
}

export default {
  name: 'adminSignin',
  components: {
    Breadcrumbs
  },
  data () {
    return {
      signingIn: false,
      userId: ''
    }
  },
  computed: {
    breadcrumbs: function () {
      return [
        {label: this.text.navHome, to: '/'},
        {label: 'Admin Signin'}
      ]
    }
  },
  methods: {
    signIn: function () {
      if (this.userId) {
        this.signingIn = true
        db.collection('adminSignin')
          .add({
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            userId: this.userId
          })
          .then(docRef => {
            let unsubscribe = docRef.onSnapshot(doc => {
              if (doc.exists) {
                let token = doc.data().token
                if (token) {
                  // Remove listener
                  unsubscribe()
                  // Remove adminSignin doc
                  docRef.delete()
                    .catch(error => { logError('AdminSignin_signIn_1', error) })
                  firebase.auth().signInWithCustomToken(token)
                    .then(() => {
                      // Route to Home page
                      this.$router.push('/')
                    })
                    .catch(error => { logError('AdminSignin_signIn_2', error) })
                }
              }
            })
          })
          .catch(error => { logError('AdminSignin_signIn_3', error) })
      }
    }
  },
  props: ['text', 'user']
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AdminSignin.vue